import * as Yup from "yup";

//TODO: PhoneInputField
const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const validationSchema = Yup.object().shape({
    hasMobilePhoneAvailable: Yup.bool()
        .nullable()
        .required("Required"),
    mobilePhoneNumber: Yup.string()
        .nullable()
        .matches(phoneRegExp, "Invalid")
        .when("hasMobilePhoneAvailable", {
            is: true,
            then: Yup.string().required("Required"),
        }),
    hasContractBeenPrinted: Yup.bool()
        .nullable()
        .when("hasMobilePhoneAvailable", {
            is: false,
            then: Yup.bool().oneOf([true], "Must provide a mobile number or present the contract to the patient"),
        }),    
});
